var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{on:{"click":_vm.buttonAction}},[(_vm.loading)?[_c('beat-loader',{staticClass:"text-xs",attrs:{"size":"12px","color":"white"}})]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }